<template>
  <el-container v-loading="loading" style="background:white;">
    <el-main id="top" class="font_16" style="padding-left:20px;padding-right:20px;padding-top:70%;">
      <el-row>
        <div style="width:350px;text-align:center;">
          <p>Webでのログインを確認しました。<br>アプリストアより、専用アプリをインストール/起動してログインしてください。</p>
        </div>
      </el-row>
      <el-row>
        <div>
          <a v-if="isIos" :href=appStoreLink target="_blank">App Store で NiLIMo アプリを開く</a>
          <a v-if="!isIos" :href=playStoreLink target="_blank">Google Play で NiLIMo アプリを開く</a>
        </div>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import ConstParam from '../views/js/const';

export default {
  created() {
    this.isIos = this.checkIos();
  },
  mounted() {
    window.addEventListener('resize', this.setWindowSize);
    this.setWindowSize();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.setWindowSize)
  },
  data() {
    return {
      isIos: false,
      appStoreLink: ConstParam.appStore,
      playStoreLink: ConstParam.playStore
    };
  },
  methods: {
    checkIos() {
      if (navigator.userAgent.match(/iPhone|iPad/)) {
        return true;
      } else {
        return false;
      }
    },
    setWindowSize() {
      const top = document.getElementById('top');
      let height = document.documentElement.clientHeight;
      top.style.paddingTop = parseInt(height * 0.4) + "px";
    }
  }
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
</style>